import { EVENTS } from "../../../../js/constants";

class SearchBar {
  /**
   * @param {HTMLElement} element - the search results wrapper element
   */
  constructor(element) {
    this.openClass = "is-open";
    this.element = element;
    this.closeButton = element.querySelector(".js-SearchBar-closeButton");
    this.openButtons = document.querySelectorAll(
      ".js-SearchBar-openButton, .js-MetaNavigation-searchBarOpenButton"
    );
    this.searchInput = element.querySelector(".js-SearchBar-input");

    this.autocompleteField = element.querySelector(
      ".js-SearchBar-autocompleteResults"
    );
    this.searchButton = element.querySelector(".js-SearchBar-searchButton");
    this.endpointUrlAttr = element.getAttribute("data-endpoint-url");
    this.endpointUrl = this.endpointUrlAttr
      ? `${window.location.origin}/${this.endpointUrlAttr}`
      : null;

    this.bind();
  }

  /**
   * bind
   */
  bind() {
    this.openButtons.forEach((openButton) => {
      openButton.addEventListener("click", this._switchState.bind(this));
    });
    this.closeButton.addEventListener("click", this._switchState.bind(this));

    if (this.endpointUrl) {
      this.searchInput.addEventListener(
        "input",
        this._inputSearchAutocomplete.bind(this)
      );
    }
  }

  /**
   * toggles openClass on the element and body; moves focus to the input[text] when the searchbar is open
   *
   * @private
   */
  _switchState() {
    this.element.classList.toggle(this.openClass);
    const isOpen = this.element.classList.contains(this.openClass);

    if (isOpen) {
      this.searchInput.focus();
    }

    this.element.dispatchEvent(
      new CustomEvent(EVENTS.MODAL_OPEN, {
        bubbles: true,
        detail: { isOpen },
      })
    );
  }

  /**
   * Fetches autocomplete suggestions based on `searchInput` value from a specific endpoint `url`.
   * It then creates and attaches new button fields to the `autocompleteField`.
   * These buttons, when clicked or "Enter" key is pressed, set the search input to their content and clear the `autocompleteField`.
   *
   * @returns {Promise<void>} Resolves to undefined if successful, console logs any fetch error.
   */
  async _inputSearchAutocomplete() {
    const queryString = new URLSearchParams({
      keywords: this.searchInput.value,
    }).toString();
    const url = new URL(this.endpointUrl);
    url.search = queryString;

    let content;
    try {
      const response = await fetch(url.toString(), { method: "GET" });
      if (!response.ok) {
        throw new Error(`
          HTTP error! status: ${response.status}, ${response.statusText}
        `);
      }
      content = await response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Failed to fetch data: ${error}`);
      return;
    }

    const newFields = content.data.map((element) => {
      const field = document.createElement("button");
      field.classList.add("SearchBar-autocompleteResult");
      field.setAttribute("type", "button");
      field.innerHTML = element;
      field.onclick = (event) => {
        this.autocompleteField.innerHTML = "";
        this.searchInput.value = event.target.innerHTML;
      };

      field.onkeydown = (event) => {
        if (event.code === "Enter") {
          field.click();
          this.searchButton.focus();
        }
      };
      return field;
    });

    this.autocompleteField.replaceChildren(...newFields);
  }
}
export default SearchBar;
